// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.NLQSettings.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
import React, { PureComponent } from 'react';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import NLQSettingConfiguration from './Izenda.NLQSettingConfiguration';

class NLQSettings extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      show: true
    };
  }
  s;
  toggleShow = () => {
    this.setState({ show: !this.state.show });
  };

  render() {
    let localization = this.props.localization;
    let collapseIcon = this.state.show ? 'icon-triangle-down' : 'icon-triangle-right';
    let titleIcon = this.state.show
      ? localization.getText('COMMON_LABEL_COLLAPSE')
      : localization.getText('COMMON_LABEL_EXPAND');
    return (
      <div>
        <div className='u-bgGray u_paddingAll'>
          <a onClick={this.toggleShow.bind(this)}>
            <span title={titleIcon} className={collapseIcon} />
          </a>
          <span>{localization.getText('NLQ_CONFIGURATION_SETTINGS_LABEL_TITLE')}</span>
        </div>
        {this.state.show && (
          <GridLayout className='u-bgWhite u_paddingAll'>
            <NLQSettingConfiguration {...this.props} />
          </GridLayout>
        )}
      </div>
    );
  }
}
export default NLQSettings;



// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/NlqConfiguration/Izenda.NLQSettings.js